module.exports = __webpack_public_path__ + "img/设备图2@3x.fc6e5ba2.png";